import { fromJS } from 'immutable';
import { dispatch } from 'nike-re-framejs';
import { getFbsCurrentInterval } from 'nike-ui/src/components/fbs/api';

let interval = null;

export function loadCharityData() {
    getFbsCurrentInterval().then(data => {
        if (data.value && data.step && data.until) {
            if (interval === null) {
                interval = setInterval(() => dispatch(updateValue), 1000);
            }
            dispatch(db => db.set('charity', fromJS(data)));
        }
    });
}

function updateValue(db) {
    const charity = db.get('charity');
    if (!charity) return;
    const now = Date.now();
    const { value, step, until } = charity.toJS();
    if (now >= until) {
        dispatch(loadCharityData);
    }
    return db.setIn(['charity', 'value'], value + step);
}

export function charityCleanup() {
    clearInterval(interval);
    interval = null;
}
